import React, { forwardRef } from 'react';
import './Button.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'text';
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  isLoading?: boolean;
  icon?: string;
  iconAlt?: string;
  appearance?: 'default' | 'icon';
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ 
  children, 
  variant = 'primary', 
  size = 'medium',
  isLoading = false,
  className = '', 
  disabled,
  icon,
  iconAlt,
  appearance = 'default',
  ...props
}, ref) => {
  const buttonClasses = [
    'button',
    `button-${variant}`,
    `button-${size}`,
    appearance === 'icon' && 'button-icon-only',
    isLoading && 'button-loading',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      ref={ref}
      className={buttonClasses}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <div className="button-spinner" />
      ) : (
        <>
          {icon && (
            <img 
              src={icon} 
              alt={iconAlt || ''} 
              className="button-icon-image"
            />
          )}
          {children}
        </>
      )}
    </button>
  );
});

Button.displayName = 'Button';

export default Button; 